import React from 'react';
const ArrowLeft = () => (
  <svg viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" width="20" height="33">
    <path d="M762.256694 947.106726 240.124939 512 762.256694 76.893274 783.874037 102.83204 292.876374 512 783.874037 921.16796Z" />
  </svg>
);
export default ArrowLeft;
